import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '@/interface/LoginPage.vue';
import DashboardPage from '@/interface/DashboardPage.vue';
import VisitorPage from '@/interface/visitProject/VisitorPage.vue';
import TokenLieBiaoPage from '@/interface/TokenLieBiaoPage.vue';
import ShuaituMorPPage from '@/interface/stzbxl/ShuaituMorPPage.vue';
import MenuPage from '@/interface/MenuPage.vue';

const routes = [
  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/visitorPage',
    name: 'VisitorPage',
    component: VisitorPage,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: 'tokenLieBiaoPage' },
      {
        path: 'tokenLieBiaoPage', 
        name: 'TokenLieBiaoPage',
        component: TokenLieBiaoPage
      }
    ]
  },
  {
    path: '/dashboardPage',
    name: 'DashboardPage',
    component: DashboardPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/ShuaituMorPPage',
    name: 'ShuaituMorPPage',
    component: ShuaituMorPPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/MenuPage',
    name: 'MenuPage',
    component: MenuPage,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 导航守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token'); // 假设使用 token 存储认证信息

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: 'LoginPage' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;

